module.exports = __webpack_public_path__ + "static/media/yellowHydrant.fe20e665.jpg";